import { object } from 'yup';
import * as yup from 'yup';

export const IndividualSignUpFormValidationSchema = object().shape({
  firstName: yup.string().required('Please enter your first name.'),
  lastName: yup.string().required('Please enter your second name.'),
  email: yup
    .string()
    .matches(
      /^[\w.-]+(\+[\w.-]+)?@[a-zA-Z0-9-]+\.[a-zA-Z]{2,4}$/,
      'Please enter a valid email.'
    )
    .required('Please enter your email.'),
  phone: yup.string().required('Please enter your phone number.'),
  password: yup
    .string()
    .required('Please enter a password.')
    .min(8, 'Password must be at least 8 characters long.')
    .matches(/(?=.*[0-9])/, 'Password must contain a number.'),
  confirmPassword: yup
    .string()
    .required('Please confirm your new password.')
    .oneOf([yup.ref('password')], 'Passwords must match.'),
  acceptTerms: yup.boolean().required().oneOf([true]),
});

export const BusinessSignUpFormValidationSchema = object().shape({
  firstName: yup.string().required('Please enter your first name.'),
  lastName: yup.string().required('Please enter your second name.'),
  companyName: yup.string().required("Please enter your company's name."),
  email: yup
    .string()
    .matches(
      /^[\w.-]+(\+[\w.-]+)?@[a-zA-Z0-9-]+\.[a-zA-Z]{2,4}$/,
      'Please enter a valid email.'
    )
    .required('Please enter your email.'),
  phone: yup.string().required('Please enter your phone number.'),
  password: yup
    .string()
    .required('Please enter a password.')
    .min(8, 'Password must be at least 8 characters long.')
    .matches(/(?=.*[0-9])/, 'Password must contain a number.'),
  confirmPassword: yup
    .string()
    .required('Please confirm your new password.')
    .oneOf([yup.ref('password')], 'Passwords must match.'),
  acceptTerms: yup.boolean().required().oneOf([true]),
});
